<template>
  <!-- This template is used to show previews of wordpress pages when the user presses the preview button in wordpress -->
  <div>
    <Loading :loading="loading">
      <div id="wp-content">
        <!-- Iterate through layouts in page -->
        <!-- Essentially each layout is a row -->
        <BaseLayout v-for="(layout, index) in layouts" :key="index" :layoutData="layout"/>
        <vue-headful :title="pageTitle" :description="pageDescription" :keywords="pageKeywords"/>
      </div>
    </Loading>
  </div>
</template>

<script>
import { fetchWordpressPreview } from "../network/wordpressRequests";
import Loading from "@/components/loading/Loading";

import BaseLayout from "./layouts/BaseLayout";

export default {
  name: "WordpressContentPage",
  components: {
    Loading,
    BaseLayout
  },
  // props: ["url"],
  data: () => {
    return {
      pageData: null,
      loading: true
    };
  },
  created() {
    this.loadData();
  },
  watch: {
    //update data whenever a parameter changes
    "$route.query.url"() {
      this.loadData();
    }
  },
  methods: {
    loadData() {
      this.loading = true;
      // Check login status before loading data
      let url = this.$route.query.url;
      fetchWordpressPreview(
        { url: url }, //id of page in wordpress
        result => {
          this.pageData = result;
          this.loading = false;
        },
        error => {
          this.$router.push({
            name: "404",
            query: { from: "wordpressPreview", slug: url, error: error }
          });
        }
      );
    }
  },
  computed: {
    layouts() {
      if (!this.pageData) return [];

      return this.pageData.acf.layouts;
    },
    pageTitle() {
      if (
        this.pageData &&
        this.pageData.acf &&
        this.pageData.acf.title &&
        this.pageData.acf.title != ""
      ) {
        return this.pageData.acf.title;
      }
      return "Cherrytree";
    },
    pageDescription() {
      if (
        this.pageData &&
        this.pageData.acf &&
        this.pageData.acf.description &&
        this.pageData.acf.description != ""
      ) {
        return this.pageData.acf.description;
      }
      return "Cherrytree, the club for smart shoppers";
    },
    pageKeywords() {
      if (
        this.pageData &&
        this.pageData.acf &&
        this.pageData.acf.keywords &&
        this.pageData.acf.keywords != ""
      ) {
        return this.pageData.acf.keywords;
      }
      return "Cherrytree, wholesale, shopping, brands, discount";
    }
  }
};
</script>

<style lang="scss">
</style>
